export type IArg = [criteria: string | boolean | undefined, className: string];

/**
 * Joins `baseClass` with every class whose criteria is truthy. Computed during
 * render (not in an effect) so server-rendered HTML carries the same classes as
 * the client, avoiding unstyled content and layout shifts before hydration.
 */
export const useClassNames = (baseClass: string, args: IArg[]): string => {
  return [baseClass, ...args.filter((arg: IArg) => Boolean(arg[0])).map((arg: IArg) => arg[1])]
    .filter(Boolean)
    .join(' ');
};
